import ApiCore from './api-core'
import { IDENTIFY } from '@/constants/api-types'

export default class Payment extends ApiCore {
  constructor(store) {
    const path = `${IDENTIFY}/payment`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
